Pixlee.module('Entities', function(Entities, App, Backbone, Marionette, $) {
    Entities.SlimUser = Entities.Model.extend({
        canAccess: function(feature) {
            // normalize to prevent case errors
            feature = feature.toLowerCase();

            return _.contains(this.get('features'), feature);
        },
        canUserAccess: function(feature) {
            // normalize to prevent case errors
            feature = feature.toLowerCase();
            var features = this.get('user_features');

            // Master automatically has all permissions
            return _.contains(features, 'master') || _.contains(features, feature);
        }
    });

    App.reqres.setHandlers({
        'set:current:user': function(currentUser) {
            // 2021/02/26 - To differentiate between CP and Photos. CP has the new webpack stuff, but Photos doesnt
            // We can't just check Packs directly because it's undefined in photos, so would throw an error
            if (window.Packs && Packs.Application) {
                return new Packs.Application.Entities.CurrentUser(currentUser);
            }
            if (Entities.User) {
                return new Entities.User(currentUser);   
            }
            return new Entities.SlimUser(currentUser);
        },
    });
});
